import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-area" }
const _hoisted_2 = {
  key: 0,
  class: "main-area__main-content main-content"
}
const _hoisted_3 = { class: "main-content__content-container content-container" }
const _hoisted_4 = { class: "content-container__header" }
const _hoisted_5 = { class: "content-container__title" }
const _hoisted_6 = { class: "content-container__edit-field-container edit-field-container" }
const _hoisted_7 = { class: "number-field-container" }
const _hoisted_8 = { class: "number-field-container__min-title" }
const _hoisted_9 = { class: "number-field-container__max-title" }
const _hoisted_10 = { class: "number-field-container__number-field" }
const _hoisted_11 = ["value", "step", "min", "max"]
const _hoisted_12 = { class: "number-field-container__number-field" }
const _hoisted_13 = ["value", "step", "min", "max"]
const _hoisted_14 = { class: "content-container__button-container button-container" }

import SimpleSelectField from '@/components/input/SimpleSelectField.vue';
import { computed, onMounted, reactive, watch } from 'vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import {
  MAX_OF_CHANGE_DATE,
  MIN_OF_CHANGE_DATE,
  STEP_OF_CHANGE_DATE,
  STEP_OF_CHANGE_MONTH,
  UNIT_OF_DAY,
  UNIT_OF_MONTH_SIMPLE,
  UNIT_OF_WEEK_SIMPLE,
} from '@/coreDomainsModule/constants';
import { StdIndexInfo } from '@/appLogic/interfaces/inventory';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { DateUnitType } from '@/coreDomainsModule/date';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'StdInventoryPicker',
  props: {
    popupState: { type: Boolean },
    stdInventoryInfo: {}
  },
  emits: ["onClose", "onConfirm", "onConfirmedInvalidValue", "onUpdateStdInventory"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

// emits
const emits = __emit;

// イベントフック
onMounted(() => {
  state.popupState = props.popupState;
  updateInfo(props.stdInventoryInfo);
});

watch(
  () => props.popupState,
  (newVal) => {
    state.popupState = newVal;
    if (state.popupState) {
      updateInfo(props.stdInventoryInfo);
    }
  }
);

watch(
  () => props.stdInventoryInfo,
  (newVal) => {
    updateInfo(newVal);
  }
);

// computed
// 数値入力のステップ
const stepOfNumberField = computed(() => {
  switch (state.selectedDateUnit) {
    case 'month':
      return STEP_OF_CHANGE_MONTH;
    default:
      return STEP_OF_CHANGE_DATE;
  }
});

// 変数
const state = reactive<{
  popupState: boolean;
  minNumber: number;
  maxNumber: number;
  selectedDateUnit: DateUnitType;
}>({
  popupState: false,
  minNumber: 0,
  maxNumber: 0,
  selectedDateUnit: 'day',
});

// ドロップダウンの選択肢
const options = [
  { label: UNIT_OF_DAY, value: 'day' },
  { label: UNIT_OF_WEEK_SIMPLE, value: 'week' },
  { label: UNIT_OF_MONTH_SIMPLE, value: 'month' },
];

// 関数

/**
 * 表示に使用する情報を更新する
 * @param value 標準在庫指数情報
 */
const updateInfo = (value: StdIndexInfo) => {
  if (value === undefined) {
    return;
  }
  state.minNumber = value.min;
  state.maxNumber = value.max;
  const selectedDateUnit = DateService.convertToIDateUnit(value.unit);
  if (selectedDateUnit !== 'unknown') {
    state.selectedDateUnit = selectedDateUnit;
  } else {
    // NOTO: 単位情報が'unknown'だったらerror出しとく
    const error = new Error(`Error: stdInventory unit is 'unknown'`);
    console.error(error);
  }
};

/**
 * 最小値の変更を受け取る
 * @param event 最小値入力フィールドのonChangeイベント
 */
const onChangeMinNumber = (event: Event) => {
  if (event.target instanceof HTMLInputElement) {
    const minNumber = Number(event.target.value);
    if (minNumber.isValidNumber({})) {
      state.minNumber = minNumber;
    }
  }
};
/**
 * 最大値の変更を受け取る
 * @param event 最大値入力フィールドのonChangeイベント
 */
const onChangeMaxNumber = (event: Event) => {
  if (event.target instanceof HTMLInputElement) {
    const maxNumber = Number(event.target.value);
    if (maxNumber.isValidNumber({})) {
      state.maxNumber = maxNumber;
    }
  }
};
/**
 * 日付単位の変更を受け取る
 * @param unit 日付単位
 */
const onChangeDateUnit = (unit) => {
  if (unit !== undefined) {
    state.selectedDateUnit = unit;
  }
};

/**
 * 最小値と最大値を丸める
 * @param min 最小値
 * @param max 最大値
 * @param selectedUnit 日付単位
 * @returns 丸めた最小値と最大値 or エラー
 */
const roundMinMaxValues = (min: number, max: number, selectedUnit: DateUnitType): { min: number; max: number } | Error => {
  // 最大値と最小値の間に収める
  min = min.clamp(MIN_OF_CHANGE_DATE, MAX_OF_CHANGE_DATE);
  max = max.clamp(MIN_OF_CHANGE_DATE, MAX_OF_CHANGE_DATE);
  if (min > max) {
    // 最小値が最大値より大きい場合は、無効な入力として呼び出し元に知らせる
    return new Error('Error: min is greater than max');
  }
  // 必要に応じて小数点以下を切り捨てる
  min = DateService.roundDisplayDate(min, selectedUnit);
  max = DateService.roundDisplayDate(max, selectedUnit);
  return { min, max };
};

/**
 * 確定ボタン押下
 */
const onConfirm = () => {
  const displayValue = roundMinMaxValues(state.minNumber, state.maxNumber, state.selectedDateUnit);
  if (displayValue instanceof Error) {
    // 無効な入力として呼び出し元に知らせる
    emits('onConfirmedInvalidValue');
    console.error(displayValue);
    return;
  }
  emits('onConfirm', {
    name: props.stdInventoryInfo.name,
    min: displayValue.min,
    max: displayValue.max,
    unit: state.selectedDateUnit,
  });
};

/**
 * DB上の標準在庫指数の情報を更新する
 */
const onUpdateStdInventory = () => {
  const displayValue = roundMinMaxValues(state.minNumber, state.maxNumber, state.selectedDateUnit);
  if (displayValue instanceof Error) {
    // 無効な入力として呼び出し元に知らせる
    emits('onConfirmedInvalidValue');
    console.error(displayValue);
    return;
  }
  emits('onUpdateStdInventory', {
    name: props.stdInventoryInfo.name,
    min: displayValue.min,
    max: displayValue.max,
    unit: state.selectedDateUnit,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "outside-area",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
    }, null, 512), [
      [_vShow, state.popupState]
    ]),
    (state.popupState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('標準在庫指数')), 1),
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-ss',
                class: "content-container__update-default",
                onClick: onUpdateStdInventory
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('デフォルト値更新:1')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(_unref(t)('デフォルト値更新:2')), 1)
                ], undefined, true),
                _: 1,
                __: [2]
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('Min')), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('Max')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("input", {
                    class: "number-field",
                    type: "number",
                    value: state.minNumber,
                    step: stepOfNumberField.value,
                    min: _unref(MIN_OF_CHANGE_DATE),
                    max: state.maxNumber,
                    onChange: onChangeMinNumber
                  }, null, 40, _hoisted_11)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "number-field-container__separator" }, "ー", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("input", {
                    class: "number-field",
                    type: "number",
                    value: state.maxNumber,
                    step: stepOfNumberField.value,
                    min: state.minNumber,
                    max: _unref(MAX_OF_CHANGE_DATE),
                    onChange: onChangeMaxNumber
                  }, null, 40, _hoisted_13)
                ])
              ]),
              _createVNode(SimpleSelectField, {
                class: "edit-field-container__date-unit",
                options: options,
                "selected-value": state.selectedDateUnit,
                "onUpdate:modelValue": onChangeDateUnit
              }, null, 8, ["selected-value"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-ss',
                class: "button-container__button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClose')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(TextButton, {
                color: 'primary',
                size: 'btn-ss',
                class: "button-container__button",
                onClick: onConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('確定')), 1)
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})